import { notifyWidgetProvider } from "../components/AdaptiveCardWidget/AdaptiveCardRenderingAndActions";
import widgetApiVersion from "../widgetRuntime/apis/api.interfaces";
import { getWidgetOrchestrator } from "../widgetRuntime/orchestrator/orchestrator";
export async function getWidgetRegistrationsPromise() {
    return await getWidgetOrchestrator().then((result) => result.getWidgetRegistrations());
}
export async function getWidgetInstancesPromise() {
    return await getWidgetOrchestrator().then((result) => result.getWidgetInstances());
}
export async function getFeedsInstancePromise() {
    return await getWidgetOrchestrator().then((orchestrator) => orchestrator
        .getFeedInstance()
        .then((result) => {
        return result;
    })
        .catch((reason) => {
        return undefined;
    }));
}
export async function getWidgetInstancePromise(index) {
    const widgetInstances = await getWidgetInstancesPromise();
    return widgetInstances[index];
}
export async function addWidgetInstance(widgetRegistration) {
    return await getWidgetOrchestrator().then((result) => {
        return result.addWidgetInstance(widgetRegistration);
    });
}
export async function removeWidgetInstance(widgetInstance) {
    await getWidgetOrchestrator().then((result) => {
        result.removeWidgetInstance(widgetInstance);
    });
}
export async function addWidgetOrchestratorEventListener(orchestratorCallback) {
    await getWidgetOrchestrator().then((result) => {
        return result.addEventListener(orchestratorCallback);
    });
}
export async function removeWidgetOrchestratorEventListener(orchestratorCallback) {
    await getWidgetOrchestrator().then((result) => {
        result.removeEventListener(orchestratorCallback);
    });
}
export async function getWidgetElementAsync(widgetInstance) {
    return await getWidgetOrchestrator().then((result) => {
        return result.getWidget(widgetInstance);
    });
}
export async function getWidgetStatus(widgetInstance) {
    await widgetInstance.widgetInitializationPromise();
    const statusApi = widgetInstance.tryGetApi("status", 1, widgetApiVersion);
    if (statusApi) {
        return statusApi.getStatus();
    }
    return "";
}
export async function addWidgetStatusEventListener(widgetInstance, statusUpdateCallback) {
    await widgetInstance.widgetInitializationPromise();
    const statusApi = widgetInstance.tryGetApi("status", 1, widgetApiVersion);
    if (statusApi) {
        statusApi.addStatusEventListenerInternal(statusUpdateCallback);
    }
}
export async function removeWidgetStatusEventListener(widgetInstance, statusUpdateCallback) {
    if (widgetInstance) {
        await widgetInstance.widgetInitializationPromise();
        const statusApi = widgetInstance.tryGetApi("status", 1, widgetApiVersion);
        if (statusApi) {
            statusApi.removeStatusEventListenerInternal(statusUpdateCallback);
        }
    }
}
export async function addWidgetVisibilityEventListener(widgetInstance, statusUpdateCallback) {
    await widgetInstance.widgetInitializationPromise();
    const visibilityApi = widgetInstance.tryGetApi("visibility", 1, widgetApiVersion);
    if (visibilityApi) {
        visibilityApi.addEventListener(statusUpdateCallback);
    }
}
export async function removeWidgetVisibilityEventListener(widgetInstance, statusUpdateCallback) {
    if (widgetInstance) {
        await widgetInstance.widgetInitializationPromise();
        const visibilityApi = widgetInstance.tryGetApi("visibility", 1, widgetApiVersion);
        if (visibilityApi) {
            visibilityApi.removeEventListener(statusUpdateCallback);
        }
    }
}
export async function onTitleInteracted(widgetInstance) {
    await widgetInstance.widgetInitializationPromise();
    let widgetInteractions = widgetInstance.tryGetApi("interactions", 1, widgetApiVersion);
    if (widgetInteractions) {
        widgetInteractions.onTitleInteracted();
    }
}
export async function onSettingsInteracted(widgetInstance) {
    await widgetInstance.widgetInitializationPromise();
    let widgetInteractions = widgetInstance.tryGetApi("interactions", 1, widgetApiVersion);
    if (widgetInteractions) {
        widgetInteractions.onSettingsInteracted();
    }
}
export async function onWidgetPositionUpdated(widgetInstance) {
    await widgetInstance.widgetInitializationPromise();
    let widgetInteractions = widgetInstance.tryGetApi("interactions", 1, widgetApiVersion);
    if (widgetInteractions) {
        widgetInteractions.onWidgetPositionUpdated();
    }
}
export async function onWidgetVisible(widgetInstance) {
    await widgetInstance.widgetInitializationPromise();
    if (widgetInstance.widgetRegistration.isAdaptiveCard) {
        notifyWidgetProvider(widgetInstance, { "eventKind": "visibility", "visibilityKind": "visible" });
    }
    const visibilityApi = widgetInstance.tryGetApi("visibility", 1, widgetApiVersion);
    if (visibilityApi) {
        visibilityApi.onVisible();
    }
}
export async function onWidgetHidden(widgetInstance) {
    await widgetInstance.widgetInitializationPromise();
    if (widgetInstance.widgetRegistration.isAdaptiveCard) {
        notifyWidgetProvider(widgetInstance, { "eventKind": "visibility", "visibilityKind": "hidden" });
    }
    const visibilityApi = widgetInstance.tryGetApi("visibility", 1, widgetApiVersion);
    if (visibilityApi) {
        visibilityApi.onHidden();
        // The widget becoming hidden should also remove it from the edit state
        const settingsApi = widgetInstance.tryGetApi("settings", 1, widgetApiVersion);
        if (settingsApi) {
            settingsApi.hideSettings();
        }
    }
}
export async function getWidgetProperty(widgetInstance, property) {
    await widgetInstance.widgetInitializationPromise();
    const propertiesApi = widgetInstance.tryGetApi("properties", 1, widgetApiVersion);
    if (propertiesApi) {
        return propertiesApi[property];
    }
    return undefined;
}
export async function setWidgetProperty(widgetInstance, property, value) {
    return widgetInstance.setWidgetProperty(property, value);
}
export async function addWidgetPropertiesEventListener(widgetInstance, propertyChangeCallback) {
    await widgetInstance.widgetInitializationPromise();
    const propertiesApi = widgetInstance.tryGetApi("properties", 1, widgetApiVersion);
    if (propertiesApi) {
        propertiesApi.addPropertyChangeListener(propertyChangeCallback);
    }
}
export async function removeWidgetPropertiesEventListener(widgetInstance, propertyChangeCallback) {
    if (widgetInstance) {
        await widgetInstance.widgetInitializationPromise();
        const propertiesApi = widgetInstance.tryGetApi("properties", 1, widgetApiVersion);
        if (propertiesApi) {
            propertiesApi.removePropertyChangeListener(propertyChangeCallback);
        }
    }
}
export async function isConfigurationSupported(widgetInstance) {
    await widgetInstance.widgetInitializationPromise();
    const settingsApi = widgetInstance.tryGetApi("settings", 1, 1);
    if (settingsApi) {
        return settingsApi.isConfigurationSupported();
    }
    return false;
}
export async function showSettings(widgetInstance) {
    await widgetInstance.widgetInitializationPromise();
    const settingsApi = widgetInstance.tryGetApi("settings", 1, widgetApiVersion);
    if (settingsApi) {
        settingsApi.onShowSettingsStart();
        settingsApi.onShowSettingsEnd();
    }
}
export async function hideSettings(widgetInstance) {
    await widgetInstance.widgetInitializationPromise();
    const settingsApi = widgetInstance.tryGetApi("settings", 1, widgetApiVersion);
    if (settingsApi) {
        settingsApi.onHideSettingsStart();
        settingsApi.onHideSettingsEnd();
    }
}
export async function setupShowHideSettingsListeners(widgetInstance, widgetSettingsEventsCallback) {
    await widgetInstance.widgetInitializationPromise();
    const settingsApi = widgetInstance.tryGetApi("settings", 1, widgetApiVersion);
    if (settingsApi) {
        settingsApi.addEventListenerInternal(widgetSettingsEventsCallback);
    }
}
export async function removeShowHideSettingsListeners(widgetInstance, widgetSettingsEventsCallback) {
    if (widgetInstance) {
        await widgetInstance.widgetInitializationPromise();
        const settingsApi = widgetInstance.tryGetApi("settings", 1, widgetApiVersion);
        if (settingsApi) {
            settingsApi.removeEventListenerInternal(widgetSettingsEventsCallback);
        }
    }
}
export async function updateSize(widgetInstance, size, event) {
    await widgetInstance.widgetInitializationPromise();
    const sizeApi = widgetInstance.tryGetApi("sizes", 1, 1);
    if (sizeApi) {
        if (event === "onSizeChangeStart") {
            sizeApi.fireStartEvent(size);
        }
        else if (event === "onSizeChangeEnd") {
            sizeApi.fireEndEventAndUpdateSize(size);
        }
    }
}
export async function onWidgetRemoved(widgetInstance) {
    if (widgetInstance) {
        await widgetInstance.widgetInitializationPromise();
        if (widgetInstance.widgetRegistration.isAdaptiveCard) {
            notifyWidgetProvider(widgetInstance, { WidgetAPI: "Removed" });
        }
        const lifecycleApi = widgetInstance.tryGetApi("lifecycle", 1, widgetApiVersion);
        if (lifecycleApi) {
            // Wait for the lifecycle api to notify widget and then remove instance
            await lifecycleApi.onWidgetRemoved().then(() => {
                removeWidgetInstance(widgetInstance);
            });
        }
    }
}
export async function isRiverInstance(widgetInstance) {
    let orchestrator = await getWidgetOrchestrator();
    return (orchestrator && orchestrator.isRiverInstance(widgetInstance));
}
export async function onWidgetRemovedFromRiver(widgetInstance, isHide) {
    if (widgetInstance) {
        await widgetInstance.widgetInitializationPromise();
        const lifecycleApi = widgetInstance.tryGetApi("lifecycle", 1, widgetApiVersion);
        if (lifecycleApi) {
            // Wait for the lifecycle api to notify widget and then remove instance
            await lifecycleApi.onWidgetRemoved().then(() => {
                getWidgetOrchestrator().then((result) => {
                    result.removeWidgetInstanceFromRiver(widgetInstance, isHide);
                });
            });
        }
    }
}
